export default function (text: string) {
  if (text) {
    const code = `000` + text;
    return `#${code.slice(code.length - 3)}`;
  }
  return "-";
}
